module.exports = __webpack_public_path__ + "img/pdf-file.5342f742.svg";